import segment from 'util/analytics/segment'

type Action =
  | 'opened'
  | 'closed'
  | 'completed_login'
  | 'completed_sign_up'
  | 'completed_opening_selection'
  | 'completed_details'
  | 'completed_review'
  | 'completed_confirmation'
  | 'completed_cancel'
  | 'completed_cancel_confirmation'
  | 'completed_availability'

export interface ITrackData {
  schoolId: number
  sessionId: string
}

const events = {
  closed: 'Closed',
  completed_cancel: 'Completed Cancel',
  completed_cancel_confirmation: 'Completed Cancel Confirmation',
  completed_confirmation: 'Completed Confirmation',
  completed_details: 'Completed Details',
  completed_login: 'Completed Login',
  completed_opening_selection: 'Completed Opening Selection',
  completed_review: 'Completed Review',
  completed_sign_up: 'Completed Sign Up',
  completed_availability: 'Completed Availability',
  opened: 'Opened',
}

export function track(action: Action, data: ITrackData) {
  segment.track(`Schedule Tour Modal ${events[action]}`, data)
}

export function trackTourRequest(action: Action, data: ITrackData) {
  segment.track(`Tour Request Modal ${events[action]}`, data)
}
